import { Contrato } from './contrato.model';
import { Dispositivo } from './dispositivo.model';

export class Package{
    nome: string;
    selector: string;
    contrato: Contrato;
    dispositivo: Dispositivo;
}